import triggerGetUpdatedCookieWhitelistByTermly from './triggerGetUpdatedCookieWhitelistByTermly'

export default triggerGetUpdatedCookieWhitelistByTermly
